import { Button, Modal } from '@/components/ui';
import { useTranslations } from '@/shared/i18n';
import { useChatStore } from '@/store/chat.store';

/**
 * Подтверждение отправленной жалобы.
 *
 * Показывается не в диалоге, а на экранах, куда человек после жалобы попадает:
 * сам диалог к этому моменту закрыт, и окно исчезло бы вместе с ним — ровно
 * тогда, когда человек ждёт ответа, что его услышали. Из случайного разговора
 * он оказывается в анкете, из сохранённого — в «Моих чатах».
 */
export function ReportSentNotice(): React.ReactNode {
  const dictionary = useTranslations();
  const reportSent = useChatStore((state) => state.reportSent);
  const dismiss = useChatStore((state) => state.dismissReportSent);

  return (
    <Modal open={reportSent} title={dictionary.report.sentTitle} onClose={dismiss}>
      <p className="mb-4 text-center text-[14px] leading-relaxed text-text-muted">
        {dictionary.report.sentText}
      </p>
      <Button onClick={dismiss}>{dictionary.common.close}</Button>
    </Modal>
  );
}
